import { Buffer } from 'buffer';

if (typeof window !== 'undefined') {
  window.global = window as any;
  window.Buffer = Buffer;
  (window as any).process = { env: {} };
}

export {};
